// API endpoint configuration
export const FACTSHEETS_ENDPOINT = import.meta.env.VITE_GX_FACTSHEETS_ENDPOINT;

// URL parameter names
export const FACTSHEET_PARAM_NAME = 'indexInformation';
export const ADDITIONAL_TABS_PARAM_NAME = 'additionalTabs';
export const FACTSHEET_TAB_PARAM_NAME = 'indexInformationTab';

// Tab names as constants to avoid magic strings
export const TAB_NAMES = {
  CHART: 'Chart',
  DETAILS: 'Details',
  QUALITY_SPEC: 'Quality spec',
  CRITERIA: 'Criteria',
  APPROACH: 'Approach',
  FLOWCHART: 'Flowchart',
  AVAILABLE_ITEMS: 'Available items',
  RELATED_CODES: 'Related codes'
} as const;

// Tab position ordering
export const TAB_POSITIONS = {
  CHART: 0,
  DETAILS: 1,
  QUALITY_SPEC: 2,
  CRITERIA: 3,
  APPROACH: 4,
  FLOWCHART: 5,
  AVAILABLE_ITEMS: 6,
  RELATED_CODES: 99 // Always last
} as const;
